import React, { useEffect, useState, useContext } from "react";
import Screen from '../components/Screen';
import { i18nValue } from '../functions';
import { useDetail } from "../hooks/useDetail";
import Carousel from 'react-bootstrap/Carousel'
import { getCDNImage } from '../globals'
import { T } from "react-translator-component";
import { HotelContext } from "../context/hotel";
import { UserContext } from "../context/user";
import { useParams } from 'react-router';
import { NavLink, useLocation } from 'react-router-dom';
import { Button } from 'react-bootstrap'
import processHtml from '../components/processHtml';
import CardList from "../components/CardList";
import { useItems } from "../hooks/useItems";
import { useNavigate } from "react-router";

const Detail = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { entity, id } = useParams();
  const { language } = useContext(UserContext);
  const { data: { code: hotelCode }, placeholders } = useContext(HotelContext);
  const { loading, item, images, error, loadItem } = useDetail(entity);
  const { loading: loadingItems, items, error: errorItems } = useItems(entity);

  const [childrenList, setChildrenList] = useState([]);

  const [buttonMenu, setButtonMenu] = useState(null);
  const [btnReservationId, setBtnReservationId] = useState(null);

  console.log('4feb - id', id)

  useEffect(() => {
    console.log('27eneAA --- item', item);
    console.log('27eneAA --- item?.id', item?.id);
    console.log('27eneAA --- id', id || null);

    if (item && item.id === id) {
      const childrenData = localStorage.getItem(`ViCo::children-${item.id}`);
      console.log('27ene busco children', childrenData);
      if (childrenData) {
        const { children } = JSON.parse(childrenData);
        console.log('27ene children ->', children);
        setChildrenList(children);
      }

      if (entity === "restaurants") {
        console.log('entity', item);
        setBtnReservationId(item?.bookableItemId);
      }

      //TODO_G: Cambiar por PH link (Botones a cartas)
      if (entity === "facilities") {
        if (id === "2841e301-8ddd-4cdf-9cb4-71b4d77fbc2e") {
          // GOLD GYM - dev-matias
          setButtonMenu({
            title: T("facilities.Carta_Belleza"),
            id: "9a80c182-ceb9-4ec2-8ba2-2e45061d93e8"
          });
        }
        if (id === "911bc16d-1b1f-4395-a10c-24471e6f8e59") {
          // Costa Galana - Salon de Belleza
          setButtonMenu({
            title: T("facilities.Carta_Belleza"),
            id: "5553f77a-fbf4-4431-aecd-2f461221b1b8"
          });
        }
        if (id === "659c0198-649f-4d55-b937-559e130c560b") { //facilitie TRATAMIENTOS DE ESTADO PURO
          // Costa Galana - Carta Spa 
          setButtonMenu({
            title: T("facilities.Carta_SPA"),
            id: "cbc3ce81-a7b5-4487-a659-952f0c4501e5"
          });
        }

      }

      console.log('entity', entity);

    } else {
      loadItem(id)
    }

  }, [item, id]);

  useEffect(() => {
    if (items?.children) {
      console.log('items - children -->', items.children);
      setChildrenList(items.children);
    }
  }, [items]);

  const handleOpenBookableItemId = (e, bookableItemId) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(`/${hotelCode}/public/booking/${bookableItemId}/restaurants__${id}`, { replace: true });
  }

  return (
    <Screen
      section={`${entity}_detail`}
      headerTranslucid={true}
      title={i18nValue(item, 'name', language)}
    >
      {loading && <div className="loading text-center mt-5"><div className="spinner-border"></div></div>}
      {error && <p>Error... {error}</p>}

      {item && <>
        <div className="header-detail-with-slider">
          {images.length > 0 &&
            <Carousel
              controls={true}
              indicators={true}>
              {images.map((val, idx) => {
                return (
                  <Carousel.Item key={`home-slider-item-${idx}`}>
                    <img
                      className="d-block w-100"
                      src={getCDNImage(val)}
                      style={{ objectFit: 'cover' }}
                    />
                  </Carousel.Item>
                )
              })}
            </Carousel>}
        </div>

        <h5 className="page-detail-title mb-0">{i18nValue(item, 'name', language)}</h5>
        {item.horary && <>
          <p className="mb-3 font-sm">{i18nValue(item, 'horary', language)}</p>
        </>}
        {(item.m2 || item.m2 === 0) && item.m2 > 0 && (
          <>
            <p className="mb-3 font-sm">{item.m2}m2</p>
          </>
        )}
        <p className="page-detail-description mt-2" style={{ whiteSpace: "break-spaces" }}>{processHtml(i18nValue(item, 'description', language, placeholders))}</p>
        {item?.options && item?.options.length > 0 && <>
          <h6 className="page-detail-subtitle">{T('general.features')}</h6>
          <ul>
            {item.options.map((val, idx) => {
              return <li className="page-detail-description" key={idx}>{T('room-categories.' + val)}</li>
            })}
          </ul>
        </>}
        {item.equipment && <>
          <h6 className="page-detail-subtitle">{T('general.equipment')}</h6>
          <ul>
            {item.equipment.map((val, idx) => {
              return <li className="page-detail-description">{T(`${entity}.${val}`)}</li>
            })}
          </ul>
        </>}

        {item.url && <>
          <a href={item.url} target="_blank" rel="noopener noreferrer">
            <Button
              size={'lg'}
              variant={'primary'}
              type={'button'}
              className="page-detail-subtitle w-100">{T('general.go_to_website')}</Button>
          </a>
        </>}


        {entity === "restaurants" && item?.menus && item?.menus.length > 0 && (
          <div>
            {/* <h6 className="page-detail-subtitle">{T('general.menu')}</h6> */}
            <div className="mb-3">
              {item.menus.map((menu, idx) => {
                return (
                  <NavLink
                    key={idx}
                    to={{ pathname: `menu/${menu.id}`, id: menu.id }}
                    state={{ from: pathname }}
                    className="mb-2 d-block w-100 text-center"
                    style={{ color: '#555', border: "1px solid #CCC", textTransform: 'uppercase', height: 50, backgroundColor: "#EEE", lineHeight: "50px", fontWeight: "bold", borderRadius: 8 }}
                  >
                    {i18nValue(menu, 'name', language)}
                  </NavLink>
                );
              })}
            </div>
          </div>
        )}

        {buttonMenu && (
          <div>
            <div className="mb-3">
              <NavLink
                to={{ pathname: `menu/${buttonMenu.id}`, id: buttonMenu.id }}
                state={{ from: pathname }}
                className="mb-2 d-block w-100 text-center"
                style={{ color: '#555', border: "1px solid #CCC", textTransform: 'uppercase', height: 50, backgroundColor: "#EEE", lineHeight: "50px", fontWeight: "bold", borderRadius: 8 }}
              >
                {/* {i18nValue(menu, 'name', language)} */}
                {buttonMenu.title}
              </NavLink>
            </div>
          </div>
        )}

        {childrenList && (
          <CardList
            data={childrenList}
            language={language}
            entity={`attractions`}
            relativePath={`attractions`}
          />
        )}

      </>}

      {btnReservationId && <div>
        <button
          block={true}
          style={{ position: "absolute", top: 15, right: 10, zIndex: 10, boxShadow: '0 2px 8px rgba(0,0,0,0.5)' }}
          className="btn btn-secondary btn-booking-book"
          onClick={(e) => handleOpenBookableItemId(e, btnReservationId)}
        // disabled={buttonSaveDisabled}
        >{String(T("general.reserve"))?.toUpperCase()}
        </button>
      </div>}
    </Screen>
  );
}

export {
  Detail
}